import { Box, Button, Flex, Grid, List, Modal, Text, TextInput,Select } from '@mantine/core';
import { IconEdit, IconLocation, IconPlus, IconSearch } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { api, get_details_from_pincode } from '../services/master.service';
import { joiResolver, useForm } from '@mantine/form';
import Joi from 'joi';
import { showErrorToast, showSuccessToast } from '../utilities/Toast';
import { useMediaQuery } from '@mantine/hooks';
import { openConfirmModal } from '@mantine/modals';
import { is_mobile_view } from '../config';
import { useQuery } from 'react-query';

function AddAddressModal({ opened, onClose, isEditing, editData }) {
  const [cities, setCities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let isMobileScreen = useMediaQuery('(max-width: 768px)');
  isMobileScreen = is_mobile_view ? is_mobile_view : isMobileScreen;

  const [areaList, setAreaList] = useState([]);
  // const area_data = useQuery({
  //   queryKey: ["areas-data"],
  //   queryFn: () => api.get_counter_areas(),
  //   onSuccess: (data) => {
  //     if (data.success) {
  //       setAreaList(data.data);
  //     }
  //   },
  // });

  const cityId = localStorage.getItem("city_id") ?? "";
  const filteredAreas = areaList.filter(
    (item) => item.city_id.toString() === cityId
  );

  const area_data = useQuery({
  queryKey: ["areas-data", cityId],
  queryFn: () => api.get_counter_areas({ city_id: cityId }),
  enabled: !!cityId,
  onSuccess: (data) => {
    if (data.success) {
      setAreaList(data.data);
    }
  },
});

  useEffect(() => {
    api.get_cities().then((res) => {
      let data = res.data.data;
      let flat = data.flatMap((e) => e.city);
      setCities(flat);
    });
  }, []);

  useEffect(() => {
    if (isEditing) {
      console.log(editData);
      // const counter = editData.counter;
      // const street = editData.address_line_1;
      // const areaId = areaList.find((item) => item.id === street)?.area ?? null; 
      // console.log(areaId,street,areaList,area_data);
      form.setValues({
        first_name: editData.first_name,
        address_line_1: editData.address_line_1.toString(),
        address_line_2: editData.address_line_2,
        phone_no: editData.phone_no,
        address_title: editData.address_title,
        pincode: editData.pincode,
        city: editData.city,
        state: editData.state,
        country: editData.country,
      });
    } else {
      form.reset();
    }
  }, [isEditing, editData]);

  const schema = Joi.object({
    address_title: Joi.string().required(2),
    first_name: Joi.string().required(2),
    phone_no: Joi.string().required(2),
    address_line_1: Joi.string().required(2),
    address_line_2: Joi.string().required(2),
    pincode: Joi.string().required(2).min(6),
    city: Joi.string().required(2),
    state: Joi.string().required(2),
    country: Joi.string().required(2),
    latitude: Joi.any().allow('', null),
    longitude: Joi.any().allow('', null),
  });

  const form = useForm({
    initialValues: {
      address_title: '',
      first_name: '',
      phone_no: '',
      address_line_1: '',
      address_line_2: '',
      pincode: '',
      city: '',
      state: '',
      country: '',
      latitude: '',
      longitude: '', 
    },
    validate: joiResolver(schema),
  });
/*
const getCurrentLocation = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        form.setFieldValue('latitude', position.coords.latitude);
        form.setFieldValue('longitude', position.coords.longitude);
      },
      (error) => {
        console.log(error);
        showErrorToast({
          title: "Error",
          message: "Please allow location access",
        });
      }
    );
  }
};


useEffect(() => {
  if (opened) {
    getCurrentLocation();
  }
}, [opened]);
*/


  const handlePinCodeChange = async (pincode) => {
    setIsLoading(true);
    await get_details_from_pincode.get_address_details(pincode).then((res) => {
      setIsLoading(false);
      console.log(res.data);
      if (res.data[0].Status !== 'Success') {
        showErrorToast({
          title: 'Error',
          message: 'Pincode Not Found',
        });
      } else {
        form.setValues({
          city: res.data[0].PostOffice[0].District,
          state: res.data[0].PostOffice[0].Circle,
          country: res.data[0].PostOffice[0].Country,
        });
        // console.log('id :', form.getFieldValue('id'));
      }
    });
  };

  const addAddress = async (values) => {
    if (isEditing) {
      setIsLoading(true);
      await api.edit_address({ ...values, id: editData.id, city_id: cityId }).then((res) => {
        setIsLoading(false);
        console.log(res.data);
        if (res.data.success) {
          showSuccessToast({
            title: 'Success',
            message: 'Successfully edited address.',
          });
          onClose();
        } else {
          showErrorToast({
            title: 'Error',
            message: 'Error editing address.',
          });
        }
      });
    } else {
      setIsLoading(true);
      await api.add_address({
        ...values,
        counter_id: localStorage.getItem("counter_id"),
      }).then((res) => {
        setIsLoading(false);
        console.log(res.data);
        if (res.data.success) {
          showSuccessToast({
            title: 'Success',
            message: 'Successfully added address.',
          });
          onClose();
        } else {
          showErrorToast({
            title: 'Error',
            message: 'Error adding address.',
          });
        }
      });
    }
  };

  const confirmEditAddress = (values) => {
    openConfirmModal({
      title: (
        <Flex align="center" gap={10}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#0D4715',
              background: 'linear-gradient(135deg, #eaf8ee, #ffffff)',
              border: '1px solid rgba(34, 197, 94, 0.18)',
            }}
          >
            <IconEdit size={17} />
          </Box>
          <Box>
            <Text fw={900} size="md" color="#111827">
              Update Address
            </Text>
            <Text size={12} color="#667085" mt={2}>
              Confirm changes to this delivery location
            </Text>
          </Box>
        </Flex>
      ),
      centered: true,
      children: (
        <Box
          p={14}
          sx={{
            background: 'linear-gradient(135deg, #eaf8ee, #ffffff)',
            border: '1px solid rgba(34, 197, 94, 0.18)',
            borderRadius: 16,
          }}
        >
          <Text size="sm" color="#475467" lh={1.55}>
            Do you want to save these address changes?
          </Text>
        </Box>
      ),
      labels: { confirm: 'Yes, Update', cancel: 'Cancel' },
      confirmProps: {
        radius: 'xl',
        variant: 'gradient',
        gradient: { from: 'green.7', to: 'green.5' },
      },
      cancelProps: {
        radius: 'xl',
        variant: 'outline',
        color: 'gray',
      },
      styles: {
        content: {
          borderRadius: 22,
          border: '1px solid rgba(34, 197, 94, 0.18)',
          boxShadow: '0 28px 80px rgba(13, 71, 21, 0.20)',
        },
        header: {
          padding: '20px 20px 8px',
        },
        body: {
          padding: '8px 20px 20px',
        },
      },
      onConfirm: () => addAddress(values),
    });
  };

  return (
    <div>
      <Modal
        opened={opened}
        onClose={onClose}
        styles={{ header: { borderBottom: '1px solid #eee' }, body: { padding: 0 } }}
        title={
          <Box px={10}>
            {isEditing ? (
              <Flex align={'center'}>
                <IconEdit size={16} />
                <Text ml={14} size={'16px'}>
                  Edit Address
                </Text>
              </Flex>
            ) : (
              <Flex align={'center'}>
                <IconPlus size={16} />
                <Text ml={14} size={'16px'}>
                  Add New Address
                </Text>
              </Flex>
            )}
          </Box>
        }
        size={'760px'}
        centered
      >
        <Box p={20}>
          <form
            onSubmit={form.onSubmit((values) => {
              if (isEditing) {
                confirmEditAddress(values);
              } else {
                addAddress(values);
              }
            })}
          >
            <Grid gutter={'lg'}>
              <Grid.Col span={12}>
                <TextInput
                  placeholder="Enter Home / Office"
                  label="Address Title"
                  {...form.getInputProps('address_title')}
                />
              </Grid.Col>
              <Grid.Col span={isMobileScreen ? 12 : 6}>
                <TextInput
                  placeholder="Enter Name"
                  label="First Name"
                  {...form.getInputProps('first_name')}
                />
              </Grid.Col>
              <Grid.Col span={isMobileScreen ? 12 : 6}>
                <TextInput
                  placeholder="Enter Phone Number"
                  label=" Phone Number"
                  {...form.getInputProps('phone_no')}
                />
              </Grid.Col>
              <Grid.Col span={isMobileScreen ? 12 : 6}>
                {/* <TextInput
                  placeholder="Enter Street Name"
                  label="Street Name"
                  {...form.getInputProps('address_line_1')}
                /> */}
                {/* <Select
                  //   searchable
                  //   placeholder="Select Street/Area"
                  //   label="Enter Street Name"
                  //   // mt="xs"
                  //   maxDropdownHeight={180}
                  //   allowDeselect
                  //   value={form.values.address_line_1}
                  //   error={form.errors.address_line_1}
                  //   data={filteredAreas.map((item) => ({
                  //     value: item.id.toString(),
                  //     label: item.area
                  //   }))}
                  //   onChange={(value) => {
                
                  //     const selectedArea = filteredAreas.find(a => a.id.toString() === value);
                
                  //     if (selectedArea) {
                  //       form.setFieldValue("address_line_1", value);
                  //       // form.setFieldValue("counter_id", selectedArea.counter_id);
                  //     }
                
                  //   }}
                  //   styles={{
                  //   option: {
                  //     '&[data-hovered]': {
                  //       backgroundColor: '#9bfdad',
                  //       color: '#f9fcfa'
                  //     },
                  //     '&[data-selected]': {
                  //       backgroundColor: '#2f9e44',
                  //       color: 'white'
                  //     }
                  //   }
                  // }}
                  /> */}
                  {areaList.length > 0 ? (
                       <Select
                         searchable
                         placeholder="Select Street/Area"
                         label="Enter Street Name"
                         maxDropdownHeight={180}
                         allowDeselect
                         value={form.values.address_line_1}
                         error={form.errors.address_line_1}
                         data={areaList.map((item) => ({
                           value: item.area,   // ✅ store NAME not ID
                           label: item.area
                         }))}
                         onChange={(value) => {
                           form.setFieldValue("address_line_1", value);
                         }}
                         styles={{
                           option: {
                             '&[data-hovered]': {
                               backgroundColor: '#9bfdad',
                               color: '#f9fcfa'
                             },
                             '&[data-selected]': {
                               backgroundColor: '#2f9e44',
                               color: 'white'
                             }
                           }
                         }}
                       />
                      ) : (
                       <TextInput
                         placeholder="Enter Street Name"
                         label="Enter Street Name"
                         {...form.getInputProps('address_line_1')}
                       />
                      )}


              </Grid.Col>
              <Grid.Col span={isMobileScreen ? 12 : 6}>
                <TextInput
                  placeholder="Enter Door No. / Building Name / Apartment Name"
                  label="Landmark"
                  {...form.getInputProps('address_line_2')}
                />
              </Grid.Col>
              <Grid.Col span={isMobileScreen ? 12 : 3}>
                <TextInput
                  disabled={isLoading}
                  placeholder="Enter Pincode"
                  label=" Pincode"
                  {...form.getInputProps('pincode')}
                  onChange={(e) => {
                    form.setFieldValue('pincode', e.target.value);
                    e.target.value.length > 5 && handlePinCodeChange(e.target.value);
                  }}
                />
              </Grid.Col>
              <Grid.Col span={isMobileScreen ? 12 : 3}>
                <TextInput
                  // placeholder="Enter Address Line 2"
                  label="City"
                  {...form.getInputProps('city')}
                  disabled
                />
              </Grid.Col>
              <Grid.Col span={isMobileScreen ? 12 : 3}>
                <TextInput
                  // placeholder="Enter Address Line 2"
                  label="State"
                  {...form.getInputProps('state')}
                  disabled
                />
              </Grid.Col>
              <Grid.Col span={isMobileScreen ? 12 : 3}>
                <TextInput
                  // placeholder="Enter Address Line 2"
                  label=" Country"
                  {...form.getInputProps('country')}
                  disabled
                />
              </Grid.Col>
            </Grid>
            <Button mb={10} w={'100%'} mt={24} type="submit" disabled={isLoading}>
              {isEditing ? 'Edit Address' : 'Add New Address'}
            </Button>
          </form>
        </Box>
      </Modal>
    </div>
  );
}

export default AddAddressModal;
